var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{staticClass:"tooltip-modal"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("modal-title"),_vm._v(" "),_c('button',{staticClass:"modal-header__close",on:{"click":_vm.closeModal}})],2),_vm._v(" "),_vm._t("modal-content")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }